export default "__VITE_ASSET__B5T8gTYd__"